import { PartnerUserPermissions } from "providers/Auth";
import { ApplicationStatus } from "shared/types";
import { ApplicationActions } from "shared/utils/application-actions";

const NO_PERMS = {
  canCancelApplications: false,
  canChangeUnit: false,
  canMakeDecisions: false
} as PartnerUserPermissions;

/**
 * @deprecated Use ApplicationActions.inviteApplicant directly
 */
export const getInviteApplicationDisabledToolTip = (
  applicationStatus?: ApplicationStatus
) => {
  if (!applicationStatus) return undefined;
  return new ApplicationActions({
    status: applicationStatus,
    permissions: NO_PERMS
  }).inviteApplicant.tooltip;
};
